var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{main: _vm.main},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.initCheck)?_c('router-view',{staticStyle:{"margin":"0 auto"}}):_vm._e()],1),(_vm.loggedIn)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }